import { Flex, List, styled } from '@shared/components';

import {
  BackToPortalMenuItem,
  LogoutMenuItem,
  NotificationMenuItem,
  UserMenuItem,
} from '../menu-item/composed-menu-item';

import Clock from './clock';
import SidebarToggleButton from './sidebar-toggle-button';

const BottomMenu = styled(Flex)(({ theme }) => ({
  position: 'sticky',
  bottom: 0,
  flexDirection: 'column',
  marginTop: 'auto',
  borderTop: '1px solid',
  borderColor: theme.palette.grey[300],
  backgroundColor: 'white',
  width: '100%',
}));

interface SidebarStickyMenuProps {
  minified?: boolean;
  hideToggleButton?: boolean;
  onClickNotificationMenuItem?: () => void;
}

function SidebarStickyMenu(props: Readonly<SidebarStickyMenuProps>) {
  const {
    minified: shouldMinified,
    hideToggleButton: shouldHideToggleButton,
    onClickNotificationMenuItem,
  } = props;
  return (
    <BottomMenu>
      <List>
        <Clock minified={shouldMinified} />
        <UserMenuItem minified={shouldMinified} />
        <NotificationMenuItem minified={shouldMinified} onClick={onClickNotificationMenuItem} />
        <BackToPortalMenuItem minified={shouldMinified} />
        <LogoutMenuItem minified={shouldMinified} />
      </List>
      {!shouldHideToggleButton ? <SidebarToggleButton /> : null}
    </BottomMenu>
  );
}

export default SidebarStickyMenu;
